import { render, staticRenderFns } from "./data-table-customClass-editor.vue?vue&type=template&id=2f18cb15&scoped=true&"
import script from "./data-table-customClass-editor.vue?vue&type=script&lang=js&"
export * from "./data-table-customClass-editor.vue?vue&type=script&lang=js&"
import style0 from "./data-table-customClass-editor.vue?vue&type=style&index=0&id=2f18cb15&prod&lang=scss&scoped=true&"
import style1 from "./data-table-customClass-editor.vue?vue&type=style&index=1&id=2f18cb15&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18cb15",
  null
  
)

export default component.exports